<template>
  <div>

    <!-- 进行中的商品跟进 -->
    <div class="head">
      <div class="operation">
        <div class="search">
          <!-- 商品名称/商品ID/商品链接 -->
          <div class="item input">
            <el-input clearable v-model="datas.title_iid_link"
              :placeholder="$t('message.productName_ProductID_ProductLink')" @blur="setDefaultValue"></el-input>
          </div>
          <!-- 工厂名称/工厂ID/工厂链接 -->
          <div class="item input">
            <el-input clearable v-model="datas.shop_id_name_link"
              :placeholder="$t('message.factoryNameFactoryIDFactoryLink')" @blur="setDefaultValue"></el-input>
          </div>
          <!-- 商品管理备注 -->
          <div class="item input">
            <el-input clearable v-model="datas.remark" :placeholder="$t('message.productManagementRemarks')"
              @blur="setDefaultValue"></el-input>
          </div>
          <!-- 是否绑定辅料 -->
          <div class="item select">
            <el-select v-model="datas.has_material" :placeholder="$t('message.whetherToBindAuxiliaryMaterials')"
              clearable>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 选择产品类型 -->
          <div class="item select">
            <el-select v-model="datas.supply_type" :placeholder="$t('message.selectProductType')" clearable multiple>
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>


          <!-- 商品标签（多选） -->
          <div class="item select" style="margin-right: 0;">
            <el-select v-model="datas.flag_id" :placeholder="$t('message.productLabelMultipleChoice')" clearable
              multiple>
              <el-option v-for="item in flagList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="operation">
        <div class="search">
          <!-- 客户ID/客户名称 -->
          <div class="item input">
            <el-input clearable v-model="datas.user_id" :placeholder="$t('message.customerID_CustomerName')"
              @blur="setDefaultValue"></el-input>
          </div>
          <!-- 管理番号-->
          <div class="item input">
            <el-input clearable v-model="datas.client_sku_code" :placeholder="$t('message.managementDesignation')"
              @blur="setDefaultValue"></el-input>
          </div>
          <!-- 管理番号模糊搜索-->
          <div class="item input">
            <el-input clearable v-model="datas.client_sku_code_like"
              :placeholder="$t('message.fuzzySearchByManagementNumber')"></el-input>
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
          <!-- 重置 -->
          <el-button @click="reset">{{ $t('message.reset') }}</el-button>
          <!--  -->
        </div>
        <!-- 按钮区域 -->
        <div class="btn">
          <!-- 列表展开收起 -->
          <el-button @click="isShow">
            {{ !allShow ? $t('message.listExpansion') : $t('message.listCollapse') }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 主题内容 -->
    <div class="item-body" v-for="(item, index) in tableData" :key="index">
      <div class="user">
        <span style="margin-right: 16px;">{{ item.user.realname }}</span> {{ item.user_id }}
      </div>
      <div class="goods-content">
        <!-- 商品信息 -->
        <div class="goods-info">

          <div class="name">{{ $t('message.commodityInformation') }}</div>
          <div class="content">
            <el-image style="width:160px;height: 160px;border-radius: 6px;" :src="item.pic"
              :preview-src-list="[item.pic]">
            </el-image>
            <!-- 属性 -->
            <div class="attribute">
              <div class="tag">
                {{ item.client_sku_code }}
                <i class="el-icon-caret-right"></i>
              </div>
              <p v-for="(detail, index) in item.client_product_link[0].item_sku.detail" :key="index">
                {{ detail.key }} : {{ detail.value }}
              </p>
              <!-- 信息维护 -->
              <router-link :to="'/informationMaintenanceDetail?sys_code=' + item.sys_code" target="_blank" class="btn">
                <el-button type="primary" size="small">{{ $t('message.informationMaintenance') }}</el-button>
              </router-link>
            </div>
          </div>
        </div>
        <!--商品详情  -->
        <div class="goods-detail">
          <div class="tags">
            <div class="item" v-for="(flag, flagIndex) in item.client_product_flag" :key="flagIndex"
              :style="{ background: flag.color }">
              {{ flag.name }}
            </div>
          </div>
          <div class="table">
            <ol>
              <!-- 产品类型 -->
              <li>
                {{ $t('message.productType') }}
              </li>
              <!-- 特殊商品 -->
              <li>
                {{ $t('message.specialProducts') }}
              </li>
              <!-- 最近更新时间 -->
              <li>
                {{ $t('message.latestUpdateTime') }}
              </li>
              <!-- 尺寸/重量 -->
              <li>
                {{ $t('message.sizeWeight') }}
              </li>
            </ol>
            <ul>
              <!-- 产品类型 -->
              <li>
                <div>
                  <el-tag size="small"
                    :type="client_product_supply_type(item.client_product_supply_type, '现货') ? 'success' : 'primary'">
                    现货 {{ client_product_supply_type(item.client_product_supply_type, '现货') ? '支持' : '不支持' }}
                  </el-tag>
                  <el-tag size="small"
                    :type="client_product_supply_type(item.client_product_supply_type, 'OEM') ? 'success' : 'primary'">
                    OEM {{ client_product_supply_type(item.client_product_supply_type, 'OEM') ? '支持' : '不支持' }}
                  </el-tag>
                  <el-tag size="small"
                    :type="client_product_supply_type(item.client_product_supply_type, 'ODM') ? 'success' : 'primary'">
                    ODM {{ client_product_supply_type(item.client_product_supply_type, 'ODM') ? '支持' : '不支持' }}
                  </el-tag>
                </div>

              </li>
              <!-- 特殊商品 -->
              <li>
                <div class="illegal">
                  <div class="item" v-for="(forbid, forbidIndex) in item.forbid_type" :key="forbidIndex"
                    v-show="forbidIndex < 2">
                    <img src="@/assets/icon/illegal.png" alt="">
                    <div>{{ forbid }}</div>
                  </div>
                </div>
              </li>
              <!-- 最近更新时间 -->
              <li>
                {{ item.updated_at }}
              </li>
              <!-- 尺寸/重量 -->
              <li>
                <div>
                  <p> {{ item.length }}cm*{{ item.width }}cm*{{ item.height }}cm</p>
                  <p style="margin-top: 24px;">{{ item.weight }}g</p>
                </div>

              </li>
            </ul>
          </div>
        </div>
        <!-- 商品-订单 -->
        <div class="goods-order">
          <!-- 订单相关 -->
          <div class="name">
            {{ $t('message.orderRelated') }}
            <div class="right">
              <div class="item">
                <i class="el-icon-arrow-left" @click="switchOverOrder(index, 'left')"></i>
              </div>
              <div class="item">
                <i class="el-icon-arrow-right" @click="switchOverOrder(index, 'right')"></i>
              </div>
            </div>
          </div>
          <div class="table">
            <ol>
              <!-- 下单时间 -->
              <li>
                {{ $t('message.orderTime') }}
              </li>
              <!-- 订单号 -->
              <li class="flex2">
                {{ $t('message.orderNumber') }}
              </li>
              <!-- 番号 -->
              <li>
                {{ $t('message.mash') }}
              </li>
              <!-- 下单数量-->
              <li>
                {{ $t('message.orderQuantity') }}
              </li>
            </ol>
            <ul v-for="(order, orderIndex) in item.orderList" :key="orderIndex" v-show="orderIndex < 2"
              style="padding-top: 12px;">
              <!-- 下单时间 -->
              <li>
                {{ order.created_at }}
              </li>
              <!-- 订单号 -->
              <li class="flex2">
                <router-link :to="'/orderDetail?order_sn=' + order.order_sn" class="a-link" target="_blank"
                  style="text-align: left;">
                  {{ order.order_sn }}
                </router-link>
              </li>
              <!-- 番号 -->
              <li>
                {{ order.sorting }}
              </li>
              <!-- 下单数量-->
              <li>
                {{ order.confirm_num }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 是否展开 -->
      <div class="isShow" @click="item.show = !item.show">
        <span v-if="item.show">
          收起 <i class="el-icon-arrow-right"></i>
        </span>
        <span v-else>
          展开 <i class="el-icon-arrow-down"></i>
        </span>
      </div>
      <!-- 订单数量 -->
      <div class="orderNum" v-show="item.show">
        <!-- 购买阶段 -->
        <div class="status">
          <div class="name">
            {{ $t('message.purchaseStage') }}
            <!-- 查看订单 -->
            <router-link :to="`/user/orderList?userID=${item.user_id}&encryption=${$md5(item.user_id + '')}`" class="fr"
              target="_blank">
              <el-button type="text">{{ $t('message.lookOrder') }}</el-button>
            </router-link>
          </div>
          <div class="list">
            <!-- 购买中 -->
            <div class="item">
              <div class="img" @click="orderingDataDialog(item, 'waitBuy', $t('message.Purchasing'), 1)">
                <img src="@/assets/status-icon/购买中.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.Purchasing') }}</div>
                <div class="status-num">{{ item.orderData.waitBuy }}</div>
              </div>
            </div>
            <!-- 等待发货 -->
            <div class="item">
              <div class="img" @click="orderingDataDialog(item, 'waitSend', $t('message.PendingShipment'), 1)">
                <img src="@/assets/status-icon/等待发货.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name">{{ $t('message.PendingShipment') }}</div>
                <div class="status-num">{{ item.orderData.waitSend }}</div>
              </div>
            </div>
            <!-- 等待送达RAKUMART -->
            <div class="item">
              <div class="img"
                @click="orderingDataDialog(item, 'waitReceive', $t('message.PendingDeliveryToRakumart'), 1)">
                <img src="@/assets/status-icon/等待送达RAKUMART.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name">{{ $t('message.PendingDeliveryToRakumart') }}</div>
                <div class="status-num">{{ item.orderData.waitReceive }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 不良数据 -->
        <div class="status">
          <div class="name">
            {{ $t('message.badData') }}
            <!-- 详情 -->

            <el-button type="text" @click="problemListDetail(item, $t('message.particulars'), 4)" class="fr">{{
              $t('message.particulars') }}</el-button>

          </div>
          <div class="list">
            <!-- 不良待决策 -->
            <div class="item">
              <div class="img" @click="problemList(item, 'problemWaiClient', $t('message.DefectPendingDecision'), 1)">
                <img src="@/assets/status-icon/不良待决策.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.DefectPendingDecision') }}</div>
                <div class="status-num">{{ item.orderData.problemWaiClient }}</div>
              </div>
            </div>
            <!-- 不良处理中 -->
            <div class="item">
              <div class="img" @click="problemList(item, 'problemWaiPConfirm', $t('message.DefectInProgress'), 2)">
                <img src="@/assets/status-icon/不良处理中.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.DefectInProgress') }}</div>
                <div class="status-num">{{ item.orderData.problemWaiPConfirm }}</div>
              </div>
            </div>
            <!-- 处理完成 -->
            <div class="item">
              <div class="img" @click="problemList(item, 'problemConfirmed', $t('message.DefectResolved'), 3)">
                <img src="@/assets/status-icon/处理完成.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.DefectResolved') }}</div>
                <div class="status-num">{{ item.orderData.problemConfirmed }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- RAKUMART仓库 -->
        <div class="status noMargin">
          <div class="name">
            {{ $t('message.RAKUMARTWarehouse') }}
            <!-- 查看仓库 -->
            <router-link :to="`/user/userWarehouse?userID=${item.user_id}&encryption=${$md5(item.user_id + '')}`"
              class="fr" target="_blank">
              <el-button type="text">{{ $t('message.lookWarehouse') }}</el-button>
            </router-link>
          </div>
          <div class="list">
            <!-- 可出货数量 -->
            <div class="item">
              <div class="img" @click="orderingDataDialog(item, 'upNotSend', $t('message.ShippableQuantity'), 2)">
                <img src="@/assets/status-icon/可出货数量.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.ShippableQuantity') }}</div>
                <div class="status-num">{{ item.orderData.upNotSendNum }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 国际运送  -->
        <div class="status">
          <div class="name">
            {{ $t('message.InternationalTransport') }}
            <!-- 查看配送单 -->
            <router-link :to="`/user/deliveryOrder?userID=${item.user_id}&encryption=${$md5(item.user_id + '')}`"
              class="fr" target="_blank">
              <el-button type="text">{{ $t('message.lookPorder') }}</el-button>
            </router-link>
          </div>
          <div class="list" style="padding: 0 10px;">
            <!-- 发货单待确认 -->
            <div class="item">
              <div class="img"
                @click="orderingDataDialog(item, 'porderWaitTranslate', $t('message.ShipmentOrderPendingConfirmation'), 4)">
                <img src="@/assets/status-icon/发货单待确认.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.ShipmentOrderPendingConfirmation') }}</div>
                <div class="status-num">{{ item.orderData.porderWaitTranslate }}</div>
              </div>
            </div>
            <!-- 仓库打包中 -->
            <div class="item">
              <div class="img"
                @click="orderingDataDialog(item, 'porderWaitConfirm', $t('message.PackingInWarehouse'), 4)">
                <img src="@/assets/status-icon/仓库打包中.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name">{{ $t('message.PackingInWarehouse') }}</div>
                <div class="status-num">{{ item.orderData.porderWaitConfirm }}</div>
              </div>
            </div>
            <!-- 待付款 -->
            <div class="item">
              <div class="img" @click="orderingDataDialog(item, 'porderWaitPay', $t('message.PendingPayment'), 4)">
                <img src="@/assets/status-icon/待付款.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name">{{ $t('message.PendingPayment') }}</div>
                <div class="status-num">{{ item.orderData.porderWaitPay }}</div>
              </div>
            </div>
            <!-- 等待物流公司取件 -->
            <div class="item">
              <div class="img"
                @click="orderingDataDialog(item, 'porderwaitDelivery', $t('message.WaitingForCourier'), 4)">
                <img src="@/assets/status-icon/等待物流公司取件.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.WaitingForCourier') }}</div>
                <div class="status-num">{{ item.orderData.porderwaitDelivery }}</div>
              </div>
            </div>
            <!-- 国际运输 -->
            <div class="item">
              <div class="img"
                @click="orderingDataDialog(item, 'porderWaitReceive', $t('message.InternationalShipping'), 4)">
                <img src="@/assets/status-icon/国际运输.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name">{{ $t('message.InternationalShipping') }}</div>
                <div class="status-num">{{ item.orderData.porderWaitReceive }}</div>
              </div>
            </div>
            <!-- 已签收 -->
            <div class="item">
              <div class="img" @click="orderingDataDialog(item, 'porderReceived', $t('message.DeliverySigned'), 4)">
                <img src="@/assets/status-icon/已签收.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name">{{ $t('message.DeliverySigned') }}</div>
                <div class="status-num">{{ item.orderData.porderReceived }}</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 到着作业 -->
        <div class="status noMargin">
          <div class="name">
            {{ $t('message.timeForHomework') }}
            <!-- 查看订单 -->
            <router-link
              :to="`/user/chineseDomesticLogistics?userID=${item.user_id}&encryption=${$md5(item.user_id + '')}`"
              class="fr" target="_blank">
              <el-button type="text">{{ $t('message.lookOrder') }}</el-button>
            </router-link>
          </div>
          <div class="list" style="padding: 0 10px;">
            <!-- 已收货待作业 -->
            <div class="item">
              <div class="img"
                @click="orderingDataDialog(item, 'received', $t('message.ReceivedPendingOperations'), 3)">
                <img src="@/assets/status-icon/已收货待作业.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.ReceivedPendingOperations') }}</div>
                <div class="status-num">{{ item.orderData.received }}</div>
              </div>
            </div>
            <!-- 到着作业中 -->
            <div class="item">
              <div class="img" @click="orderingDataDialog(item, 'waitUpStorage', $t('message.ArrivalProcessing'), 3)">
                <img src="@/assets/status-icon/到着作业中.svg" alt="">
              </div>
              <div class="status-box">
                <div class="status-name"> {{ $t('message.ArrivalProcessing') }}</div>
                <div class="status-num">{{ item.orderData.waitUpStorage }}</div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20,]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 订单状态列表 -->
    <orderStatusList ref="orderStatusList" />
    <!-- 不良品列表 -->
    <problemStatusList ref="problemStatusList" />
  </div>
</template>
<script>

import orderStatusList from './components/orderStatusList'
import problemStatusList from './components/problemStatusList'
export default {
  components: {
    orderStatusList,
    problemStatusList
  },
  data() {
    return {
      allShow: false,
      datas: {
        user_id: localStorage.getItem('product_user_id') ? localStorage.getItem('product_user_id') : '',
        title_iid_link: localStorage.getItem('product_title_iid_link') ? localStorage.getItem('product_title_iid_link') : '',
        shop_id_name_link: localStorage.getItem('product_shop_id_name_link') ? localStorage.getItem('product_shop_id_name_link') : '',
        client_sku_code: localStorage.getItem('product_client_sku_code') ? localStorage.getItem('product_client_sku_code') : '',
        remark: localStorage.getItem('product_remark') ? localStorage.getItem('product_remark') : '',
        has_material: '',
        has_option: '',
        has_tag: '',
        supply_type: [],
        flag_id: [],
        page: 1,
        pageSize: 10,
        client_sku_code_like: '',
      },
      tableData: [],
      total: 0,
      options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      typeOptions: [{ label: 'OEM', value: 'OEM' }, { label: 'ODM', value: 'ODM' }],
      flagList: [],

    };
  },
  created() {
    if (this.$route.query.product_user_id) {
      this.datas.user_id = this.$route.query.product_user_id
    }
    this.$api.productManagementApi.flagList().then(res => {
      this.flagList = res.data
    })
    this.productOrderingList()
  },
  methods: {
    // 无需维护列表
    productOrderingList() {
      this.$api.productManagementApi.productOrderingList(this.datas).then(res => {
        console.log(res);
        res.data.data.forEach(item => {
          item.show = false
          item.showOrder = 0
          item.showOrderList = JSON.parse(JSON.stringify(item.orderList))
          item.orderList = item.showOrderList.slice(item.showOrder, item.showOrder + 2)
        })
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    search() {
      this.datas.page = 1
      this.productOrderingList()
    },
    reset() {
      this.datas = {
        user_id: '',
        title_iid_link: '',
        shop_id_name_link: '',
        has_material: '',
        has_option: '',
        client_sku_code: '',
        remark: '',
        has_tag: '',
        supply_type: [],
        flag_id: [],
        page: 1,
        pageSize: 10,
        client_sku_code_like: '',
      }
      this.setDefaultValue()
      this.productOrderingList()
    },
    // 展开显示
    isShow() {
      this.allShow = !this.allShow
      this.tableData.forEach(item => {
        item.show = this.allShow
      })
      this.$forceUpdate()

    },
    //更新页数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.productOrderingList()
    },
    //更新分页每页数量
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.productOrderingList()
    },
    //产品类型
    client_product_supply_type(list, name) {
      let index = list.findIndex(item => item.type_name == name)
      return index != -1
    },
    // 弹窗-具体数字明细
    orderingDataDialog(item, status, title, type) {
      let datas = {
        user_id: item.user_id,
        sys_code: item.sys_code,
      }
      this.$api.productManagementApi.orderingDataDialog(datas).then(res => {
        this.$refs.orderStatusList.list = res.data[status]
        this.$refs.orderStatusList.dialogVisible = true
        this.$refs.orderStatusList.title = title
        this.$refs.orderStatusList.type = type
      })
    },
    //不良品
    problemList(item, status, title, type) {
      let datas = {
        user_id: item.user_id,
        sys_code: item.sys_code,
      }
      this.$api.productManagementApi.orderingDataDialog(datas).then(res => {
        this.$refs.problemStatusList.list = res.data[status]
        this.$refs.problemStatusList.dialogVisible = true
        this.$refs.problemStatusList.title = title
        this.$refs.problemStatusList.type = type
      })
    },
    // 不良品详情
    problemListDetail(item, title, type) {
      let datas = {
        user_id: item.user_id,
        skuCodes: [],
      }
      item.client_product_link.forEach(item => {
        datas.skuCodes.push(item.sku_code)
      })
      this.$api.productManagementApi.problemListDetail(datas).then(res => {
        this.$refs.problemStatusList.list = res.data
        this.$refs.problemStatusList.dialogVisible = true
        this.$refs.problemStatusList.title = title
        this.$refs.problemStatusList.type = type
      })
    },
    // 切换订单
    switchOverOrder(index, type) {
      let itemData = this.tableData[index]
      if (type == 'right') {
        if (itemData.showOrderList.length > itemData.showOrder + 2) {
          itemData.showOrder += 2
        }
      } else {
        if (itemData.showOrder != 0) {
          itemData.showOrder -= 2
        }
      }
      itemData.orderList = itemData.showOrderList.slice(itemData.showOrder, itemData.showOrder + 2)
      this.$forceUpdate()
    },
    //设置默认值
    setDefaultValue() {
      localStorage.setItem('product_user_id', this.datas.user_id)
      localStorage.setItem('product_title_iid_link', this.datas.title_iid_link)
      localStorage.setItem('product_shop_id_name_link', this.datas.shop_id_name_link)
      localStorage.setItem('product_client_sku_code', this.datas.client_sku_code)
      localStorage.setItem('product_remark', this.datas.remark)
    },
  }
}
</script>
<style lang='scss' scoped>
.head {
  padding: 24px;
  background-color: #F8F8F8;
  margin-top: -24px;
}

.operation {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  background-color: #F8F8F8;

  .search {
    display: flex;

    .item {
      margin-right: 20px;
    }

    .input {
      width: 300px;
    }

    .select {
      width: 200px;
    }
  }
}

.item-body {
  padding: 24px;
  background-color: #F8F8F8;
  border-radius: 6px;
  margin-top: 58px;
  position: relative;

  .user {
    position: absolute;
    top: -42px;
    left: 0;
    padding: 11px 16px;
    background: #545467;
    border-radius: 4px 4px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #FFFFFF;

  }

  .goods-content {
    display: flex;

    .goods-info {
      .name {
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        margin-bottom: 18px;
      }

      .content {
        display: flex;
        padding-right: 30px;
        border-right: 1px solid #dedede;

        .attribute {
          width: 215px;
          margin-left: 12px;
          position: relative;

          .tag {
            width: 190px;
            height: 36px;
            background: #FFEEEE;
            border-radius: 4px;
            position: relative;
            color: #B4272B;
            padding-left: 10px;
            line-height: 36px;
            margin-bottom: 24px;

            .el-icon-caret-right {
              font-size: 57px;
              position: absolute;
              top: -10px;
              right: -35px;
              color: #FFEEEE;

            }
          }

          .btn {
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }


      }
    }

    .goods-detail {
      min-width: 786px;
      flex: 1;
      padding-left: 30px;

      .tags {
        display: flex;
        height: 24px;
        margin-bottom: 12px;

        .item {
          padding: 5px 8px;
          border-radius: 4px;
          background-color: pink;
          margin-right: 6px;
          color: #fff;
        }
      }

      .table {
        border-right: 1px solid #dedede;
        padding-right: 30px;
        height: 160px;


      }

      .el-tag {
        margin: 0 5px 5px 0;
      }

      .illegal {
        display: flex;
        flex-wrap: wrap;

        .item {
          width: 70px;
          text-align: center;
          margin-right: 6px;
          margin-bottom: 10px;

          img {
            width: 23px;
            margin-bottom: 8px;
          }
        }
      }

    }

    ol {
      border-radius: 4px;
      height: 42px;
    }

    ul {
      border-bottom: 0;
      padding: 24px 0 0;
    }

    li {
      justify-content: left;
      padding: 0 12px;

      &:nth-child(1) {
        padding-left: 24px;
      }
    }

    .flex2 {
      flex: 2;
    }

    .goods-order {
      padding-left: 30px;
      width: 546px;

      .name {
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        font-size: 18px;
        color: #333333;
        margin-bottom: 18px;

        .right {
          display: flex;

          .item {
            margin-left: 6px;
            height: 30px;
            width: 30px;
            background: #EDEFF4;
            border-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            &:hover {
              background: #FAEAE8;

              i {
                color: #CC2D2D;
              }
            }
          }
        }
      }
    }



  }

  .orderNum {
    margin-top: 24px;
    background: #FFFFFF;
    border-radius: 10px;
    border: 1px solid #DFDFDF;
    padding: 24px 24px 12px;
    display: flex;
    flex-wrap: wrap;

    .status {
      padding: 20px;
      background: #F7F8FA;
      border-radius: 10px;
      margin-right: 12px;
      margin-bottom: 12px;

      .name {
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        margin-bottom: 20px;
        line-height: 40px;
      }

      .list {
        display: flex;
        padding: 0 40px;

        .item {
          display: flex;
          margin-right: 60px;

          &:nth-last-child(1) {
            margin-right: 0;
          }

          .img {
            padding: 14px;
            background-color: #fff;
            box-shadow: 0px 6px 10px 0px rgba(96, 113, 146, 0.1);
            border-radius: 10px;
            margin-right: 14px;
            cursor: pointer;

            img {
              width: 32px;
              height: 3xpx;
            }
          }

          .status-box {
            .status-name {
              font-size: 16px;
              color: #333333;
              margin-bottom: 15px;
            }

            .status-num {
              font-weight: bold;
              font-size: 24px;
              color: #333333;
            }
          }
        }
      }
    }

    .noMargin {
      margin-right: 0;
      flex: 1;

      .list {
        justify-content: center;
        align-items: center;
      }

    }
  }

  .isShow {
    width: 66px;
    height: 30px;
    background: #F6F6F6;
    border-radius: 4px 10px 4px 4px;
    border: 1px solid #DFDFDF;
    font-size: 14px;
    color: #666666;
    line-height: 30px;
    text-align: center;
    position: absolute;
    top: 248px;
    right: 24px;
    cursor: pointer;
  }

}
</style>
